import { isAddToCartEvent } from '@nespresso/catalog-components-react/controls/AddToCartButton';

export default function navigateToProductUrl(
  event: MouseEvent,
  url: string
): void {
  if (!isAddToCartEvent(event)) {
    window.location.assign(url);
  }
}
